angular.module('pe4h').controller('ProjectClient', function($scope, $rootScope, $http, $state) {
  // Controller should be only loaded if parent controller defines $scope.project

  $scope.hired = $scope.user ? ($scope.project.HiredUserId == $scope.user.Id) : false;

  $scope.init = function(){
    
    // load possible additional data of the client
    if ($scope.myProposal){
      $http({
        url: configuration.webApi.proposals.proposals_id_client({
          id: $scope.myProposal.Id
        }),
        method: "GET"
      }).success(function(res, status, headers, config) {
          $scope.clientData = res;
      }).error(function(error, status, headers, config) {
        $scope.alertErrorFromServer(error);
        $scope.redirectHome();
      });
    }
  }
  
});